import React,{Component} from 'react'
import Truck from "../../../Svgs/Truck";
import SpecialPurposeVehicle from "../../../Svgs/SpecialPurposeVehicle";
import Bus from "../../../Svgs/Bus";
import Motorcycle from "../../../Svgs/Motorcycle";
import Trailer from "../../../Svgs/Trailer";
import PassengerCar from "../../../Svgs/PassengerCar";

class CategoryItemIcon extends Component{
   render(){
       const {iconName , width} =this.props;
        switch (iconName) {
            case "000000000000001"  :{
                return <div><Motorcycle width={width}/></div>
            }
            case "000000000000002" :{
                return <div><PassengerCar width={width}/></div>;
            }

            case "000000000000003"  :{
                return   <div><Bus width={width}/></div>
            }

            case  "000000000000004"  :{
                return <div><Truck width={width}/></div>
            }
            
            case "000000000000005"  :{
                return <div><Trailer width={width}/></div>
            }
            case "000000000000006"  :{
                return  <div><SpecialPurposeVehicle width={width}/></div>
            }
            default :return 'null'
        }
    }
}
export default CategoryItemIcon


// WEBPACK FOOTER //
// ./src/components/Calculator-board/Category-item/Category-item-icon/CategoryItemIcon.js